import React from "react"
import { StaticQuery, graphql } from "gatsby"
import classNames from "classnames"
import SEO from "../components/seo"

class Question extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showFullText: false
    }
  }

  toggleshowFullText = (e) => {
    this.setState({
      showFullText: true
    })
    e.preventDefault();
    
  }

  renderDescription = () => {
    const { data } = this.props
    const question = data.allMdx.edges[0].node.frontmatter

    const hasEllipsis = !!question.readMore
    const ellipsisClassNames = classNames("has-ellipsis is-off-desktop", {
      "is-off":  this.state.showFullText
    })

    if (hasEllipsis) {
      return (
        <p className={ ellipsisClassNames }>
          { question.description }
          <span className="ellipsis">...</span> <span className="ellipsis-text">
          { question.readMore }
          </span> 
          <a onClick={ this.toggleshowFullText } href="" className="read-more">Read more</a>
        </p>
      )
    } 

    return (
      <p>{ question.description }</p>
    )
  }

  render() {
    const data = this.props.data
    const question = data.allMdx.edges[0].node

    return (
      <article className="question">
        {<SEO
          title={question.frontmatter.title}
          description={question.frontmatter.title}
        />}

        <div className="tablet-header">{question.frontmatter.title}</div>
        <div className="owner">
          <div className="avatar">
            <img
              src={`${data.site.siteMetadata.siteUrl}/${question.frontmatter.categoryImage}`}
              className="travel-thumb"
              alt=""
            />
            <img
              src={`${data.site.siteMetadata.siteUrl}/${question.frontmatter.avatar}`}
              className="owner-thumb"
              alt=""
            />
          </div>
          <h2>{question.frontmatter.categoryName}</h2>
          <h3>{question.frontmatter.owner}</h3>
          <time>{question.frontmatter.date}</time>
        </div>
        <h2>{question.frontmatter.title}</h2>
        { this.renderDescription() }
      </article>
    )
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allMdx(filter: {fileAbsolutePath: {regex: "\\/question/"}}) {
          edges {
            node{
              frontmatter{
                title
                date
                owner
                avatar
                categoryName
                categoryImage
                likes
                stars
                description
                readMore
              }
            }
          }
        }
      }
    `}
    render={data => <Question data={data} {...props} />}
  />
)
